export default {
    "/": {
        "title": "Taoify - Küresel Satışlar için Çin Ürünleri | Bağımsız E-Ticaret Platformu",
        "desc": "Taoify, web sitesi oluşturma, çeviri, ürün yükleme, lojistik, ödeme ve pazarlama işlemlerini tek bir arka uçta birleştirir: 18 AI çalışanınız işinizi kolaylaştırır, 20 dilde mağaza açın, Çin ürünlerini dünyaya satın."
    },
    "/feature": {
        "title": "Özellikler · Mağaza açmak için ihtiyacınız olan her şey bu sayfada · Taoify",
        "desc": "Web sitesi oluşturma, çeviri, ürün yükleme, gönderi, ödeme alımı, müşteri çekme - Taoify, uluslararası satışlarda ihtiyaç duyulan 15 modülü tek bir arka uçta toplar, birden fazla aracı bir araya getirmenize gerek kalmaz."
    },
    "/ai-staff": {
        "title": "AI Çalışanları · 18 AI çalışanı, en yoğun çalışanları trafiği çekenler · Taoify",
        "desc": "18 AI çalışanından, büyüme ekibindeki 5 kişi «kimse gelmiyor» sorununu çözer: 12 adet mağaza sağlık kontrolü, 30 günlük pazarlama planı, bir ürün 9 kanala uyarlanır, otomatik pazarlama e-postalarıyla eski müşterileri geri çağırır."
    },
    "/logistics": {
        "title": "Küresel Lojistik · Elinizden müşterinin eline · Taoify",
        "desc": "İlk sevkiyat, gümrük işlemleri, ana hat, son teslimat; üç rota, ürün ve zamanlamaya göre seçin. YunExpress, Yanwen, 4PX entegre edildi, etiket, izleme ve hata yönetimi tek bir arka uçta."
    },
    "/payment": {
        "title": "Ödeme ve Tahsilat · Müşteri ne ile öderseniz onunla ödeyin · Taoify",
        "desc": "PayPal, Stripe, kredi kartı, Alipay kullanıma hazır. Döviz cinsinden alınan ödemeler, RMB olarak çekilir, T+7 gün içinde hesaba yatırılır, komisyon oranları ve vade süreleri açıkça belirtilir."
    },
    "/pricing": {
        "title": "Fiyatlar · Abonelik Paketleri + Aşamalı Komisyon · Taoify",
        "desc": "Mağaza abonelik paketine göre ücretlendirilir: Temel $15/ ay, Standart $29/ ay, Premium $59/ ay, üç aylık veya yıllık ödeme daha avantajlıdır. İşlem komisyonu aylık satış miktarına göre aşamalıdır, minimum %3."
    },
    "/cases": {
        "title": "Satıcı Örnekleri · Onlar da Aynı Şeyi Yapıyor · Taoify",
        "desc": "Yiwu süs eşyaları, Shenzhen 3C, Guangzhou giyim ve Almanya, ABD, Fransa'daki satıcılar - altı kişi, altı farklı başlangıç, aynı yöntem."
    },
    "/sign-up": {
        "title": "Mağaza Açma - Taoify Ücretsiz Kayıt Ol",
        "desc": "10 dakikada marka kendi sitesini oluşturun, sıfır kodlama, abonelik paketlerinde tüm özellikler deneme, tam döngülü. Hemen Taoify'e kayıt olun, cross-border e-ticaret yolculuğunuza başlayın."
    },
    "/for-china-sellers": {
        "title": "Çinli Satıcılara · Ürün seçimi ve fiyatlandırma dışında her şeyi biz hallediyoruz · Taoify",
        "desc": "Site oluşturma, çeviri, nakliye, etiket yazdırma, müşteri yanıtlama - cross-border satışta bu zorlukları platform sizin yerinize halledecek. Abonelik paketi + aşamalı komisyon (düşük %3'e kadar)."
    },
    "/for-global-sellers": {
        "title": "Yurtdışındaki Satıcılara: Çin'in raflarından ürün seçin, kendi mağazanızda satın · Taoify",
        "desc": "Stok sıkıştırma, envanter biriktirme: Çin'in tedarik zincirinden ürün seçin, müşteri sipariş verdikten sonra Çin depolarından doğrudan gönderin, farkı kazanın. BuyLink, 1688 ve Taobao bağlantılarınızı kendi ürünlerinize dönüştürebilir."
    },
    "/template-index": {
        "title": "Şablon Pazarı - Taoify Profesyonel Web Sitesi Temaları",
        "desc": "Her projeye uygun profesyonel web sitesi temaları, endüstriye özel birçok şablon ücretsiz kullanımda, ihtiyaçlarınıza göre marka imajınızı ve işlevlerinizi özelleştirin."
    },
    "/question": {
        "title": "Yardım Merkezi · Herhangi bir sorunuz varsa buradan başlayın · Taoify",
        "desc": "Mağaza açma, düzenleme, ürün yükleme, sipariş lojistiği, ödeme, pazarlama, hesap yetkileri - sorunlar kategorilere ayrılmış, bulamadığınızda destek bileti açın."
    },
    "/about-us": {
        "title": "Taoify Hakkında · Ne yapıyoruz",
        "desc": "Taoify, cross-border satıcılar için tümleşik bir web sitesi oluşturma platformudur: Web sitesi oluşturma, çeviri, ürün yükleme, lojistik, ödeme alımı ve pazarlama işlemlerini tek bir arka uçta gerçekleştirin."
    },
    "/privacy-policy": {
        "title": "Gizlilik Politikası · Taoify",
        "desc": "Taoify, kişisel bilgilerinizi nasıl toplar, kullanır, saklar ve korur; ayrıca verileriniz üzerindeki haklarınız hakkında."
    },
    "/terms-service": {
        "title": "Hizmet Şartları · Taoify",
        "desc": "Taoify platformu hizmetlerini kullanma şartları: hesap, mağaza, sipariş, ödeme ve sorumluluk dağılımı."
    },
    "/consumer-agreement": {
        "title": "İade Politikası · Taoify",
        "desc": "Taoify platformundaki siparişleriniz için iade ve sonrası kuralları: başvuru koşulları, işleme süreleri ve ödeme yöntemleri."
    },
    "/user-agreement": {
        "title": "Kullanıcı Sözleşmesi · Taoify",
        "desc": "Taoify'da kayıt olup kullanmadan önce lütfen şunları okuyun: Hesap kaydı, dükkan işletme kuralları ve platform hizmetleri açıklaması."
    }
}
